// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d91681e","400":"0552fa36","849":"d86f0e65"}[chunkId] + ".chunk.js";
};